<template>
    <div class="bg-wrap" >
        <Banner></Banner>
        <div class="content">
            <div class="title">
                <span >{{title}}</span>
            </div>
            <div class="paragraph">
                <p>{{p1}}</p>
            </div>
            <div class="paragraph">
                <p>{{p2}}</p>
            </div>
            <div class="paragraph">
                <p>{{p3}}</p>
            </div>
            <div class="title title2">
                {{title2}}
            </div>
            <div class="paragraph2">
                <p>{{h1}}</p>
            </div>
            <div class="paragraph2">
                <p>{{h2}}</p>
            </div>
            <div class="paragraph2">
                <p>{{h3}}</p>
            </div>
            <div class="btn">
                <label @click="back">{{btn1}}</label>
                <label @click="go">{{btn2}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        data() {
            return {
                title:"授权同意",
                p1:"由北京心脏学会、全国心血管疾病管理能力评估与建设工程(CDQI)主办，施维雅（天津）制药有限公司支持的“K速达-中国高血压健康管理项目”（以下简称“K速达项目”），计划通过线上学习训练营、数据调研、病例征集、短视频拍摄等学术活动的形式在全国范围内实施开展。",
                p2:"您同意参加、出镜项目名为“K速达-中国高血压健康管理项目”的短视频（以下简称“视频”）拍摄并将视频上传至本项目平台。其目的是为了教育与宣传，解答医生在高血压及心血管等领域常见的治疗方面的问题，进一步改善医生对高血压的管理水平。",
                p3:"该视频有机会面向医护人员及患者大众播放，也可由K速达项目主办",
                h1:"本人受邀提供上述视频，并已获知该视频目的。",
                h2:"本人授权项目主办方和支持方及其关联实体（简称“公司”）免费使用、复制、传播本人的在上述视频范围内的照片、影像、声音与记录。",
                h3:"此次授权地域为中华人民共和国境内，授权期间为自视频上传之日起10年。",
                title2:"权利授予",
                btn1:"拒绝授权",
                btn2:"同意授权",
            };
        },
        components:{
          Banner
        },
        mounted(){
        },
        methods: {
            back(){
                this.$router.replace("docStar")
            },
            go(){
                this.$router.replace("docVideo")
            },
        }
    };
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: #fff url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        font-size: 16px;
        overflow: scroll;
    }
    .content{
        width: 90%;
        margin: 0 auto;
    }
    .title{
        color: #326F51;
        font-size: 20px;
        font-weight: bold;
        margin: 10px;
    }
    .title2{
        text-align: left;
        margin: 10px 0 10px -5%;
        font-size: 16px;
    }
    .paragraph{
        text-indent: 30px;
        font-size: 12px;
        text-align: left;
        line-height: 20px;
    }
    .paragraph2{
        font-size: 12px;
        text-align: left;
        line-height: 20px;
    }
    p{
        margin: 2px 0;
    }
    .btn{
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin: 20px ;
        label{
            display: block;
            margin: 0 30px;
            padding: 5px 15px;
            color: #FFF;
            border-radius: 5px;
            font-size: 14px;
        }
        label:first-child{
            background: #b3b3b3;
        }
        label:last-child{
            background: #326F51;
        }
    }
</style>

